import { AccountServiceKeys } from './AccountServiceKeys';
import { ActivityKeys } from './ActivityKeys';
import { AttachmentServiceKeys } from './AttachmentServiceKeys';
import { CaseServiceKeys } from './CaseServiceKeys';
import { ClientServiceKeys } from './ClientServiceKeys';
import { CommodityServiceKeys } from './CommodityServiceKeys';
import { CompanyServiceKeys } from './CompanyServiceKeys';
import { FileServiceKeys } from './FileServiceKeys';
import { GroupServiceKeys } from './GroupServiceKeys';
import { InspectionServiceKeys } from './InspectionService';
import { JobServiceKeys } from './JobServiceKeys';
import { LoadboardServiceKeys, LoadboardAdminServiceKeys } from './LoadboardServiceKeys';
import { OrderServiceKeys } from './OrderServiceKeys';
import { PicklistServiceKeys } from './PicklistServiceKeys';
import { ReportServiceKeys } from './ReportServiceKeys';
import { TerminalServiceKeys } from './TerminalServiceKeys';
import { TerminalAssignmentServiceKeys } from './TerminalAssignmentServiceKeys';
import { LaneServiceKeys } from './LaneServiceKeys';
import { UserRoleServiceKeys } from './UserRoleServiceKeys';
import { UserServiceKeys } from './UserServiceKeys';
import { VehicleServiceKeys } from './VehicleServiceKeys';
import { VendorServiceKeys } from './VendorServiceKeys';
import { EquipmentServiceKeys } from './EquipmentServiceKeys';
import { InvoiceServiceKeys } from './InvoiceServiceKeys';
import { CoupaServiceKeys } from './coupa-service-keys';
import { noteServiceKeys } from './note-service-keys';
import { ContactServiceKeys } from './contact-keys';
import { StopServiceKeys } from './stop-service-keys';
import { IntegrationServiceKeys } from './integration-keys';
import { BulkImportServiceKeys } from './bulk-import-keys';

export const queryKeys = {
  account: AccountServiceKeys,
  activity: ActivityKeys,
  attachment: AttachmentServiceKeys,
  case: CaseServiceKeys,
  client: ClientServiceKeys,
  contact: ContactServiceKeys,
  commodity: CommodityServiceKeys,
  company: CompanyServiceKeys,
  equipment: EquipmentServiceKeys,
  file: FileServiceKeys,
  group: GroupServiceKeys,
  inspection: InspectionServiceKeys,
  invoice: InvoiceServiceKeys,
  job: JobServiceKeys,
  loadboard: LoadboardServiceKeys,
  loadboardAdmin: LoadboardAdminServiceKeys,
  order: OrderServiceKeys,
  picklist: PicklistServiceKeys,
  report: ReportServiceKeys,
  stop: StopServiceKeys,
  terminal: TerminalServiceKeys,
  terminalAssignment: TerminalAssignmentServiceKeys,
  lane: LaneServiceKeys,
  user: UserServiceKeys,
  userRole: UserRoleServiceKeys,
  vehicle: VehicleServiceKeys,
  vendor: VendorServiceKeys,
  coupa: CoupaServiceKeys,
  note: noteServiceKeys,
  integration: IntegrationServiceKeys,
  bulkImport: BulkImportServiceKeys,
};
